import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountModule } from 'account/account.module';
import { DevModule } from 'app/modules/dev/dev.module';
import { AuthModule } from 'auth/auth.module';
import { ProjectModule } from 'project/project.module';
import { RootModule } from 'root/root.module';
import { ChangeLogComponent } from 'shared/modules/skeleton/change-log/change-log.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => AuthModule,
  },
  {
    path: 'project',
    loadChildren: () => ProjectModule,
  },
  {
    path: 'root',
    loadChildren: () => RootModule,
  },
  {
    path: 'dev',
    loadChildren: () => DevModule,
  },
  {
    path: 'account',
    loadChildren: () => AccountModule,
  },
  {
    path: 'changelog',
    component: ChangeLogComponent,
    data: { title: 'PAGE_TITLES.changelog' },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
